<template>
    <div>
        <transition name="fade">
            <div v-if="active" :class="['overlay-wrapper', { 'dark': isDarkMode }]">
                <!-- Backdrop -->
                <div class="overlay-backdrop" @click="$emit('close')"></div>

                <!-- Content Card -->
                <transition name="slide-up">
                    <div v-if="active" class="overlay-card">
                        <div class="overlay-inner-padding">
                            <div class="overlay-header">
                                <div>
                                    <h2 class="overlay-title">Select Language</h2>
                                    <p class="overlay-subtitle">Choose your preferred language</p>
                                </div>
                                <button @click="$emit('close')" class="close-btn">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="icon-6" fill="none" viewBox="0 0 24 24"
                                        stroke="currentColor">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"
                                            d="M6 18L18 6M6 6l12 12" />
                                    </svg>
                                </button>
                            </div>

                            <div class="options-container">
                                <button v-for="item in items" :key="item.value" @click="select(item)" :class="[
                                    'option-item',
                                    { 'active': item.value === locale },
                                    { 'disabled': item.disabled }
                                ]" :disabled="item.disabled">
                                    <div class="option-content">
                                        <div :class="['icon-box', { 'active': item.value === locale }]">
                                            {{ item.icon }}
                                        </div>
                                        <div class="option-text">
                                            <span class="option-name">{{ item.name }}</span>
                                            <span class="option-label" :class="{ 'active': item.value === locale }">
                                                {{ item.engName }}
                                            </span>
                                        </div>
                                    </div>

                                    <div v-if="item.value === locale" class="check-icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" class="icon-5" viewBox="0 0 20 20" fill="currentColor">
                                            <path fill-rule="evenodd"
                                                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                                                clip-rule="evenodd" />
                                        </svg>
                                    </div>
                                </button>
                            </div>
                        </div>

                        <!-- Decoration -->
                        <div class="decoration-1"></div>
                        <div class="decoration-2"></div>
                    </div>
                </transition>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'Language',
    props: {
        textColor: {
            type: String,
            default: "text-gray-200",
        },
        active: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            items: [
                { name: "English", engName: "English", value: "en", icon: "🇺🇸", disabled: false },
                { name: "ไทย", engName: "Thai", value: "th", icon: "🇹🇭", disabled: false },
                { name: "Melayu", engName: "Brunei", value: "bn", icon: "🇧🇳", disabled: true },
                { name: "ភាสาខ្มែร", engName: "Cambodia", value: "kh", icon: "🇰🇭", disabled: true },
                { name: "Bahasa Indonesia", engName: "Indonesia", value: "id", icon: "🇮🇩", disabled: true },
                { name: "ພາສາລາວ", engName: "Laos", value: "la", icon: "🇱🇦", disabled: true },
                { name: "Bahasa Melayu", engName: "Malaysia", value: "my", icon: "🇲🇾", disabled: true },
                { name: "မြန်မာ", engName: "Myanmar", value: "mm", icon: "🇲🇲", disabled: true },
                { name: "Filipino", engName: "Philippines", value: "ph", icon: "🇵🇭", disabled: true },
                { name: "简体中文", engName: "Chinese", value: "zh-CN", icon: "🇨🇳", disabled: true },
                { name: "日本語", engName: "Japanese", value: "ja", icon: "🇯🇵", disabled: true },
                { name: "한국어", engName: "Korean", value: "ko", icon: "🇰🇷", disabled: true },
            ]
        }
    },
    computed: {
        locale() {
            return this.$i18n.locale;
        },
        isDarkMode() {
            return !this.$store.state.userLogin;
        }
    },
    methods: {
        select(item) {
            if (item.disabled) return;
            
            this.$store.commit('setLocale', item.value);
            this.$i18n.locale = item.value;
            
            setTimeout(() => {
                this.$emit('close');
            }, 150);
        }
    }
}
</script>

<style scoped>
.overlay-wrapper {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
}

.overlay-backdrop {
  position: absolute;
  inset: 0;
  transition: opacity 0.3s ease;
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  background-color: rgba(0, 0, 0, 0.4);
}

.dark .overlay-backdrop {
  background-color: rgba(0, 0, 0, 0.6);
}

.overlay-card {
  position: relative;
  width: 95%;
  max-width: 60rem;
  border-radius: 2.5rem;
  box-shadow: 0 32px 64px -12px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  border: 1px solid #f3f4f6;
  transition: all 0.3s ease;
  background-color: rgba(255, 255, 255, 0.95);
}

@media (min-width: 1024px) {
  .overlay-card {
    max-width: 75rem;
    border-radius: 3rem;
  }
}

.dark .overlay-card {
  background-color: rgba(42, 51, 61, 0.95);
  border-color: rgba(255, 255, 255, 0.1);
}

.overlay-inner-padding {
    padding: 2rem;
}

@media (min-width: 768px) {
    .overlay-inner-padding {
        padding: 2.5rem;
    }
}

.overlay-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 2rem;
}

.overlay-title {
  font-size: 1.75rem;
  line-height: 2.25rem;
  font-weight: 700;
  margin-bottom: 0.25rem;
  color: #111827;
}

@media (min-width: 1024px) {
  .overlay-title {
    font-size: 2.5rem;
    line-height: 3rem;
    margin-bottom: 0.5rem;
  }
}

.dark .overlay-title {
  color: #ffffff;
}

.overlay-subtitle {
  font-size: 1rem;
  color: #6b7280;
}

@media (min-width: 1024px) {
  .overlay-subtitle {
    font-size: 1.25rem;
  }
}

.dark .overlay-subtitle {
  color: #9ca3af;
}

.close-btn {
  padding: 0.75rem;
  border-radius: 1rem;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: #f3f4f6;
  color: #6b7280;
}

.close-btn:hover {
  transform: scale(1.1);
  color: #111827;
}

.dark .close-btn {
  background-color: rgba(255, 255, 255, 0.05);
  color: #9ca3af;
}

.dark .close-btn:hover {
  color: #ffffff;
}

.close-btn:active {
  transform: scale(0.95);
}

.options-container {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
  max-height: 60vh;
  overflow-y: auto;
  padding-right: 0.5rem;
}

/* Custom Scrollbar */
.options-container::-webkit-scrollbar {
  width: 6px;
}

.options-container::-webkit-scrollbar-track {
  background: transparent;
}

.options-container::-webkit-scrollbar-thumb {
  background: #e5e7eb;
  border-radius: 10px;
}

.dark .options-container::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.1);
}

@media (min-width: 768px) {
  .options-container {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (min-width: 1024px) {
  .options-container {
    gap: 1.5rem;
    padding-right: 1rem;
  }
}

.option-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.25rem;
  border-radius: 1.5rem;
  border: 2px solid transparent;
  cursor: pointer;
  transition: all 0.3s ease;
  background-color: #f9fafb;
  color: #374151;
  width: 100%;
}

@media (min-width: 1024px) {
  .option-item {
    padding: 1.25rem 1.5rem;
    border-radius: 1.5rem;
  }
}

.option-item:hover {
  border-color: #e5e7eb;
}

.option-item.disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.option-item.disabled:hover {
  border-color: transparent;
  transform: none;
}

.dark .option-item {
  background-color: rgba(255, 255, 255, 0.03);
  color: #d1d5db;
}

.dark .option-item:hover {
  background-color: rgba(255, 255, 255, 0.06);
  border-color: rgba(255, 255, 255, 0.1);
}

.option-content {
    display: flex;
    align-items: center;
    gap: 1rem;
}

.option-text {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
}

/* Adapted theme color to match hubthings-website project */
.option-item.active {
  background-color: #8a43f8;
  border-color: #8a43f8;
  color: #ffffff;
  box-shadow: 0 10px 15px -3px rgba(138, 67, 248, 0.3);
}

.dark .option-item.active {
    background-color: #f8457f;
    border-color: #f8457f;
    box-shadow: 0 10px 15px -3px rgba(248, 69, 127, 0.3);
}

.icon-box {
  width: 3.5rem;
  height: 3.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 1rem;
  font-size: 1.75rem;
  transition: background-color 0.2s ease;
  background-color: #ffffff;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}

@media (min-width: 1024px) {
  .icon-box {
    width: 3.5rem;
    height: 3.5rem;
    font-size: 1.75rem;
    border-radius: 1rem;
  }
}

.dark .icon-box {
  background-color: #374151;
}

.icon-box.active {
  background-color: rgba(255, 255, 255, 0.2);
  box-shadow: none;
}

.option-name {
  font-size: 1.25rem;
  font-weight: 700;
  letter-spacing: -0.025em;
}

@media (min-width: 1024px) {
  .option-name {
    font-size: 1.25rem;
  }
}

.option-label {
  font-size: 1rem;
  font-weight: 500;
  color: #6b7280;
}

@media (min-width: 1024px) {
  .option-label {
    font-size: 1rem;
  }
}

.dark .option-label {
  color: #9ca3af;
}

.option-label.active {
  color: rgba(255, 255, 255, 0.7);
}

.icon-5 {
    width: 1.25rem;
    height: 1.25rem;
}

.icon-6 {
    width: 1.5rem;
    height: 1.5rem;
}

.check-icon {
  width: 2rem;
  height: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9999px;
  background-color: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}

.decoration-1 {
  position: absolute;
  bottom: -6rem;
  right: -6rem;
  width: 16rem;
  height: 16rem;
  border-radius: 9999px;
  filter: blur(64px);
  pointer-events: none;
  background-color: rgba(138, 67, 248, 0.1); 
}

.decoration-2 {
  position: absolute;
  top: -6rem;
  left: -6rem;
  width: 16rem;
  height: 16rem;
  border-radius: 9999px;
  filter: blur(64px);
  pointer-events: none;
  background-color: rgba(248, 69, 127, 0.1);
}

/* Transitions */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.slide-up-enter-active {
  transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1);
}

.slide-up-leave-active {
  transition: all 0.3s cubic-bezier(0.7, 0, 0.84, 0);
}

.slide-up-enter,
.slide-up-leave-to {
  opacity: 0;
  transform: translateY(40px) scale(0.95);
}
</style>
